<template>
<div class="public-chart">
  <!-- 柱状图 -->
  <v-chart :forceFit="true" v-if="type==='0'" :plotBackground="plotBackground" :height="height" :data="data" :scale="scale">
    <v-tooltip />
    <v-axis :dataKey="axis1Opts.dataKey" :line="axis2Opts.line" :tickLine="axis2Opts.tickLine" :label="axis1Opts.label" />
    <v-axis :dataKey="axis2Opts.dataKey" :line="axis2Opts.line" :tickLine="axis2Opts.tickLine" :label="axis2Opts.label" />
    <v-bar position="item*score" :color="color" />
  </v-chart>
  <!-- 折线图 -->
  <v-chart :forceFit="true" v-if="type==='1'" :plotBackground="plotBackground" :height="height"  :data="data" :scale="scale">
    <v-tooltip />
    <v-axis :dataKey="axis1Opts.dataKey" :line="axis2Opts.line" :tickLine="axis2Opts.tickLine" :label="axis1Opts.label" />
    <v-axis :dataKey="axis2Opts.dataKey" :line="axis2Opts.line" :tickLine="axis2Opts.tickLine" :label="axis2Opts.label" />
    <v-line position="item*score" :color="color" :size="2" />
    <v-point position="item*score" :color="color" :size="4" shape="circle" />
  </v-chart>
  <!-- 仪表盘 -->
  <v-chart :forceFit="true" v-if="type==='2'" :plotBackground="plotBackground" :height="height" :data="data" :scale="scale">
      <v-coord type="polar" :startAngle="-202.5" :endAngle="22.5" :radius="0.75"></v-coord>
      <v-axis dataKey="score" :zIndex="2" :line="null" :label="axisLabel" :subTickCount="4" :subTickLine="axisSubTickLine" :tickLine="axisTickLine" :color="color"></v-axis>
      <v-axis dataKey="1" :show="false"></v-axis>
      <v-series gemo="point" position="score*1" shape="pointer" :color="color" :active="false"></v-series>
      <v-guide type="arc" :zIndex="0" :top="false" :start="arcGuide1Start" :end="arcGuide1End" :vStyle="arcGuide1Style" ></v-guide>
      <v-guide type="arc" :zIndex="1" :start="arcGuide2Start" :end="arcGuide2End" :vStyle="arcGuide2Style" ></v-guide>
      <v-guide type="html" :position="htmlGuidePosition" :html="htmlGuideHtml"></v-guide>
    </v-chart>
  <!-- 雷达图 :forcefit -->
  <v-chart force-fit="true" v-if="type==='3'"  :plotBackground="plotBackground" :height="height" :padding="padding" :data="data" :scale="scale">
    <v-tooltip />
    <v-axis :dataKey="axis1Opts.dataKey" :line="axis1Opts.line" :tickLine="axis1Opts.tickLine" :grid="axis1Opts.grid" />
    <v-axis :dataKey="axis2Opts.dataKey" :line="axis2Opts.line" :tickLine="axis2Opts.tickLine" :grid="axis2Opts.grid" />
    <v-legend dataKey="dvTransform" marker="circle" :offset="30" />
    <v-coord type="polar" :radius="0.8" />
    <v-line position="item*score" :color="color" :size="2" />
    <v-point position="item*score" :color="color" :size="4" shape="circle" />
    <!-- v-area不写就是线条，写就是块级 -->
    <v-area position="item*score" :color="color" />
  </v-chart>
  <!-- 条形图 -->
  <v-chart :forceFit="true" v-if="type==='4'" :plotBackground="plotBackground" :height="height" :data="data">
    <v-coord type="rect" direction="LB" />
    <v-tooltip />
    <v-axis dataKey="item"  :label="label" />
    <v-axis dataKey="score"  :label="label" />
    <v-bar position="item*score" :color="color" />
  </v-chart>
</div>
</template>

<script>
import { registerShape } from 'viser-vue';
import DataSet from '@antv/data-set';

export default {
  data() {
    return {
      data:{},
      scale:[],
      plotBackground:{},
      padding: [20, 20, 95, 20],
      axis1Opts:{},
      axis2Opts:{},
      color:'#2EB6A8',
      height: 400,
      // 仪表盘
      axisLabel: {
        offset: -16,
        textStyle: {
          fontSize: 18,
          textAlign: 'center',
          textBaseline: 'middle'
        }
      },
      axisSubTickLine: {
          length: -8,
          stroke: '#fff',
          strokeOpacity: 1,
      },
      axisTickLine: {
          length: -17,
          stroke: '#fff',
          strokeOpacity: 1,
      },
      arcGuide1Start: [0, 0.945],
      arcGuide1End: [9, 0.945],
      arcGuide1Style: {
          stroke: '#CBCBCB',
          lineWidth: 18,
      },
      arcGuide2Start: [0, 0.945],
      arcGuide2End: [this.chartData[0].score, 0.945],
      arcGuide2Style: {
          stroke: '#2EB6A8',
          lineWidth: 18,
      },
      htmlGuidePosition: ['50%', '95%'],
      htmlGuideHtml: `
          <div style="width: 300px;text-align: center;line-height:24px;position: absolute;top: -15px;">
          <p style="font-size: 16px;color: #545454;margin: 0;">`+this.chartData[0].item+`</p>
          <p style="font-size: 26px;color: #545454;margin: 0;">`+this.chartData[0].score*10+" %"+`</p>
          </div>
      `,
      // 条形图
      label: {}
    };
  },
  props:['chartData','type'],
  methods:{
    // 柱状图
    histogramChart(){
      this.data = this.chartData;
      this.scale = [{
        dataKey: 'item',
        min: 0,
      },{
        dataKey: 'score',
        min: 0,
        // max: 1,
      }];
      this.plotBackground ={
        fill:'#fff',
        radius:5
      };

      this.axis1Opts = {
        dataKey: 'item',
        line: null,
        tickLine: null,
        label:{
            textStyle: {
              fill: '#fff',
              fontSize: 12,
            },
            autoRotate: true
        }
      };
      this.axis2Opts = {
        dataKey: 'score',
        line: null,
        tickLine: null,
        label:{
            textStyle: {
              fill: '#fff',
              fontSize: 12,
            },
            autoRotate: true
        }
      };

    },
    // 折线图
    lineChar(){
      this.data = this.chartData;
      this.scale = [{
        dataKey: 'item',
        min: 0,
      },{
        dataKey: 'score',
        min: 0,
        // max: 1,
      }];
      this.plotBackground ={
        fill:'#fff',
        radius:5
      };

      this.axis1Opts = {
        dataKey: 'item',
        line: null,
        tickLine: null,
        label:{
            textStyle: {
              fill: '#fff',
              fontSize: 12,
            },
            autoRotate: true
        }
      };
      this.axis2Opts = {
        dataKey: 'score',
        line: null,
        tickLine: null,
        label:{
            textStyle: {
              fill: '#fff',
              fontSize: 12,
            },
            autoRotate: true
        }
      };
    },
    // 雷达图
    radarChart(){
      const dv = new DataSet.View().source(this.chartData);
      dv.transform({
        type: 'fold',
        fields: ['score'],
        key: 'dvTransform',
        value: 'score',
      });
      this.data = dv.rows;
      this.plotBackground ={
        fill:'#fff',
        radius:5
      };

      this.scale = [{
        dataKey: 'score',
        min: 0,
        // max: 80,
      }];

      this.axis1Opts = {
        dataKey: 'item',
        line: null,
        tickLine: null,
        grid: {
          lineStyle: {
            lineDash: null
          },
          hideFirstLine: false,
        }
      };
      this.axis2Opts = {
        dataKey: 'score',
        line: null,
        tickLine: null,
        grid: {
          type: 'polar',
          lineStyle: {
            lineDash: null,
          },
        },
      };
    },
    // 仪表盘
    dashboardChart(){
      this.data = this.chartData;
      this.plotBackground ={
        fill:'#fff',
        radius:5
      };
      this.scale = [{
        dataKey: 'score',
        min: 0,
        max: 9,
        tickInterval: 1,
        nice: false,
      }];
      registerShape('point', 'pointer', {
        draw(cfg, container) {
          let point = cfg.points[0];
          point = this.parsePoint(point);
          const center = this.parsePoint({
            x: 0,
            y: 0,
          });
          container.addShape('line', {
            attrs: {
              x1: center.x,
              y1: center.y,
              x2: point.x,
              y2: point.y + 15,
              stroke: cfg.color,
              lineWidth: 5,
              lineCap: 'round',
            }
          });
          return container.addShape('circle', {
            attrs: {
              x: center.x,
              y: center.y,
              r: 9.75,
              stroke: cfg.color,
              lineWidth: 4.5,
              fill: '#fff',
            }
          });
        }
      })
    },
    // 条形图
    barChart(){
      const dv = new DataSet.View().source(this.chartData);
      this.plotBackground ={
        fill:'#fff',
        radius:5
      };
      dv.transform({
        type: 'sort',
        callback(a, b) {
          return a.score - b.score > 0;
        },
      });
      this.axis1Opts = {
        dataKey: 'item',
        line: null,
        tickLine: null,
        label:{
            textStyle: {
              fill: '#fff',
              fontSize: 12,
            },
            autoRotate: true
        }
      };
      this.data = dv.rows;

      this.label = { 
        offset: 12,
        textStyle: {
          fill: '#fff',
          fontSize: 12,
        },
        autoRotate: true
      };
    }
  },
  created(){
    this.type==='0'?this.histogramChart():
    this.type==='1'?this.lineChar():
    this.type==='2'?this.dashboardChart():
    this.type==='3'?this.radarChart():
    this.type==='4'?this.barChart():'';
  }
};
</script>

<style lang="scss" scoped>
.public-chart{
  text-align: left;
}
</style>
